<template>
   <div
    class="page-header min-height-300"
    style="margin-right: -24px; margin-left: -34%"
    :style="{
      backgroundImage: `url(${headerIMG})`,
    }"
  >
  </div>
</template>

<script setup>
import { ref } from "vue";
import imgHeader from "../../assets/img/shapes/banner.png";

const headerIMG = ref(imgHeader);
</script>
